<div class="language-switcher d-flex align-items-center">
	<ng-select [items]="languages" bindValue="code" [(ngModel)]="selectedLang" [searchable]="false" [clearable]="false" (change)="changeLanguage($event)" class="language-select">
		<!-- Mostra solo bandiera selezionata -->
		<ng-template ng-label-tmp let-item="item">
			<span class="fi fi-{{ item.flag }}"></span>
		</ng-template>

		<!-- Mostra solo bandiere nel dropdown -->
		<ng-template ng-option-tmp let-item="item">
			<span class="fi fi-{{ item.flag }}"></span>
		</ng-template>
	</ng-select>
</div>
